export interface Tooltip_t {
    header: string;
    text: string;
}

export interface Tooltips {
    processingFees: Tooltip_t;
    chargerEmailDescription: Tooltip_t;
    onboardingBillingNotComplete: Tooltip_t;
    onboardingTasksIncompleteBillingComplete: Tooltip_t;
    onboardingTasksComplete: Tooltip_t;
}
  
// Optional: type for dynamic builder
import type { OrderAttributes } from '../../../models/order-model';

// Sample notifications array.
export const tooltips: Tooltips = {
  processingFees: {
    header: "About our processing fees",
    text: "You will be charged a minimum of $0.50 per transaction, and an additional transaction fee for this charging session.",
  },
  chargerEmailDescription: {
    header: "Charger Email",
    text: "This is the email that is associated with your charger manufacturer (this might be different from your MeanderEV email)",
  },
  onboardingBillingNotComplete: {
    header: "Attention - Set up billing for your Charger",
    text: "Your charger has been created, but you are not currently subscribed to a billing account and you have additional onboarding steps to complete.\nPlease complete the steps below.\n\nYour new annual billing to list your Charger on the MeanderEV network will be "
  },
  onboardingTasksIncompleteBillingComplete: {
    header: "Attention - Onboarding tasks for your Charger are not complete",
    text: "Your charger was created!\nBut you still have pending actions to onboard your charger(s) before they can be monetized. Your chargers will not be active on the MeanderEV Network until you complete the onboarding process. Please complete your onboarding below\n\nYour new monthly charge is "
  },
  onboardingTasksComplete: {
    header: "Update to your Charger Subscriptions",
    text: "Your charger will be registered, and your new monthly invoice will now be "
  } 
};

// Helper to format currency consistently
const formatCurrency = (amount: number | undefined | null): string => {
  const num = typeof amount === 'number' && !isNaN(amount) ? amount : 0;
  return `$${num.toFixed(2)}`;
};

// Builder for a dynamic processing fees tooltip using an order object
export const buildProcessingFeesTooltip = (order?: Partial<OrderAttributes>): Tooltip_t => {
  const partnerFee = typeof (order as any)?.partner_transaction_fee === 'number' ? (order as any).partner_transaction_fee : 0;
  const txFee = typeof (order as any)?.transaction_fee === 'number' ? (order as any).transaction_fee : 0;
  const totalFee = partnerFee + txFee;
  return {
    header: 'About our processing fees',
    text: `You will be charged a minimum of $0.50 per transaction, and an additional ${formatCurrency(totalFee)} transaction fee for this charging session.`,
  };
};